export enum PlacementOption {
  TicketDesignator = 1,
  TourCodeBox,
  EndorsementBox,
  OsiMessage,
}
